<mat-dialog-content>
  <p>
    Vill du byta parkeringsplats?
  </p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-raised-button mat-dialog-close [disabled]="isLoading" tabindex="-1">Nej</button>
  <button mat-raised-button color="primary" [disabled]="isLoading" (click)="onConfirmClick()" tabindex="1">
    @if (isLoading) {
      <mat-spinner [diameter]="20"></mat-spinner>
    }
    @if (!isLoading) {
      <span>Ja</span>
    }
  </button>
</mat-dialog-actions>
